module.exports = __webpack_public_path__ + "static/media/myphoto11.ab9a1a9c.JPG";